
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M4.5 5V8C4.5 10.2091 6.29086 12 8.5 12M4.5 5C5.05228 5 5.5 4.55228 5.5 4C5.5 3.44772 5.05228 3 4.5 3C3.94772 3 3.5 3.44772 3.5 4C3.5 4.55228 3.94772 5 4.5 5ZM12.5 5V8C12.5 10.2091 10.7091 12 8.5 12M12.5 5C13.0523 5 13.5 4.55228 13.5 4C13.5 3.44772 13.0523 3 12.5 3C11.9477 3 11.5 3.44772 11.5 4C11.5 4.55228 11.9477 5 12.5 5ZM8.5 12V15.5C8.5 16.8807 9.61929 18 11 18C12.3807 18 13.5 16.8807 13.5 15.5V14.5C13.5 13.1193 14.6193 12 16 12C17.3807 12 18.5 13.1193 18.5 14.5V17M18.5 17C17.3954 17 16.5 17.8954 16.5 19C16.5 20.1046 17.3954 21 18.5 21C19.6046 21 20.5 20.1046 20.5 19C20.5 17.8954 19.6046 17 18.5 17Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiCheckUp",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
